import React from "react";
import { EmojiType } from "../types/Types";

export const EMOJI_TYPE_TO_DISPLAY: Record<EmojiType, string> = {
    [EmojiType.HEART]: '❤️',
    [EmojiType.LAUGH]: '😂',
    [EmojiType.SHOCKED]: '😱',
    [EmojiType.CRY]: '😢',
    [EmojiType.ANGER]: '😠',
    [EmojiType.THUMB_UP]: '👍',
    [EmojiType.THUMB_DOWN]: '👎'
};

interface Props {
    onEmojiSelect: (emojiType: EmojiType) => void;
    onClose: () => void;
    position: { x: number; y: number };
}

function EmojiReactionPicker(props: Props) {
    const emojiTypes = Object.values(EmojiType);

    return (
        <div 
            className="emoji-reaction-picker"
            style={{
                position: 'fixed',
                left: `${props.position.x}px`,
                top: `${props.position.y}px`,
                zIndex: 1000
            }}
        >
            <div className="emoji-picker-container">
                {emojiTypes.map((emojiType) => (
                    <button
                        key={emojiType}
                        className="emoji-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            props.onEmojiSelect(emojiType);
                        }}
                    >
                        {EMOJI_TYPE_TO_DISPLAY[emojiType]}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default EmojiReactionPicker;
